import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  CurrencyDollarIcon,
  BankIcon,
  StripeLogoIcon,
  CrownSimpleIcon,
  ArrowRightIcon,
} from "@phosphor-icons/react";

const PERKS = [
  {
    icon: CurrencyDollarIcon,
    title: "5% flat commission",
    body: "Half of what other live-auction platforms charge. No hidden fees, no seller tiers that raise rates as you grow.",
  },
  {
    icon: BankIcon,
    title: "Instant Stripe payouts",
    body: "Funds land in your bank in minutes after buyer delivery confirmation. After 500 sales, every future payout is instant.",
  },
  {
    icon: StripeLogoIcon,
    title: "Stripe-powered checkout",
    body: "Native Apple Pay, Google Pay, all major cards. Checkout conversion is 30% higher than legacy processors.",
  },
  {
    icon: CrownSimpleIcon,
    title: "Founder Seller perks",
    body: "First 100 sellers get 0% commission for 14 days (starting the day you're approved), priority support, and a permanent Founder badge on every listing.",
  },
];

export default function WhySellersLove() {
  return (
    <section
      className="bg-gradient-to-br from-[#0b1f2a] to-[#08131a] text-white"
      data-testid="home-why-sellers"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <p className="text-sm font-semibold text-[#4FC3F7] mb-3">
              For sellers
            </p>
            <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter max-w-xl leading-tight">
              Run your store. Keep more of every sale.
            </h2>
            <p className="text-zinc-400 mt-4 max-w-lg">
              Bidorah is built seller-first. Lower fees, faster payouts, and a
              platform that doesn't compete with you.
            </p>
          </div>
          <Link to="/apply-to-sell" data-testid="home-why-sellers-apply">
            <Button className="bg-amber-400 hover:bg-amber-300 text-zinc-900 h-12 px-6 rounded-full font-bold shadow-lg shadow-amber-500/20">
              Apply as a Founder Seller <ArrowRightIcon size={16} className="ml-2" />
            </Button>
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PERKS.map((p) => (
            <div
              key={p.title}
              className="rounded-3xl p-6 bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition"
              data-testid={`seller-perk-${p.title.slice(0, 12).toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="h-11 w-11 rounded-2xl bg-[#4FC3F7]/15 text-[#4FC3F7] grid place-items-center">
                <p.icon size={20} weight="fill" />
              </div>
              <h3 className="font-display font-black text-lg tracking-tight mt-4 leading-tight">
                {p.title}
              </h3>
              <p className="text-sm text-zinc-300 mt-2 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
